import { TableBodyLine } from "@touche-lts/panel-ui/dist"

function rowKey(item: any, idx: number): string | number {
  if (item?.id != null) return item.id
  const storePart = item?.store?.id ?? item?.storeId ?? ''
  const namePart = item?.productName ?? item?.storeName ?? ''
  return `row-${idx}-${storePart}-${namePart}`
}

export default function TableBody({ elements, getBodyLineCells, productsVisible }) {
  return (
    <>
      {productsVisible && elements()?.map((item, idx) => {
        return (
          <TableBodyLine
            id={idx === 0 ? 'statistics-top-row' : undefined}
            key={rowKey(item, idx)}
            cells={getBodyLineCells(item as any)}
          />
        )
      })}
    </>
  )
}
